/* eslint-disable react/button-has-type */
import React, {FC} from 'react';
import s from './FiltersFooter.scss';
import classNames from 'classnames';
import {FiltersSubmitButton} from './FiltersSubmitButton/FiltersSubmitButton';
import {
  IProvidedTranslationProps,
  withTranslations,
} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';
import {useGlobals, withGlobals} from '../../../../globalPropsContext';
import {IGalleryGlobalProps} from '../../../galleryGlobalStrategy';
import {ConditionalRender} from '../../../../common/components/ConditionalRender/ConditionalRender';
import {ClearFiltersButton} from './ClearFiltersButton/ClearFiltersButton';

export interface IFiltersFooterProps extends IGalleryGlobalProps, IProvidedTranslationProps {
  shouldShowClearFiltersButton: boolean;
  clearFilters: Function;
}

const FiltersFooterComp: FC<IFiltersFooterProps> = ({shouldShowClearFiltersButton, clearFilters}) => {
  const {shouldShowMobile, usingExtendedGridGalleryStyles, hasFilters} = useGlobals();
  const shouldShowFooterDivider = usingExtendedGridGalleryStyles && shouldShowMobile;

  return (
    <div className={classNames(s.actions, {[s.footerDivider]: shouldShowFooterDivider})}>
      {hasFilters && shouldShowClearFiltersButton && (
        <ConditionalRender by="galleryShowFilters">
          <ClearFiltersButton onClearFilters={clearFilters} />
        </ConditionalRender>
      )}
      {shouldShowMobile && <FiltersSubmitButton />}
    </div>
  );
};

export const FiltersFooter = withGlobals(withTranslations()(FiltersFooterComp));
